import React from 'react';
import { PasswordForm, } from 'jitsi/security/components/security-dialog/web/PasswordForm';
import { translate } from 'jitsi/base/i18n/functions';
import Input from 'jitsi/base/ui/components/web/Input';
import { LOCKED_LOCALLY } from 'jitsi/room-lock/constants';
import { withStyles } from '@mui/styles';
import cx from 'clsx';
const styles = (theme) => ({
    container: {
        display: 'flex',
        alignItems: 'baseline',
        width: '100%',
        gap: theme.spacing(2),
    },
    input: {
        flex: 1,
    },
    passwordContainer: {
        marginBottom: theme.spacing(2),
    }
});
/**
 * React {@code Component} for displaying and editing the conference password.
 *
 * @augments Component
 */
class IISightPasswordForm extends PasswordForm {
    /**
     * Implements React's {@link Component#render()}.
     *
     * @inheritdoc
     * @returns {ReactElement}
     */
    render() {
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: 'info-password' }, this._renderPassword()),
            this._renderPasswordField()));
    }
    /** .........
     * Renders the password if there is any.
     *
     * @returns {ReactElement}
     */
    _renderPassword() {
        const { locked, t, classes } = this.props;
        return (locked && (React.createElement("div", { className: this.props.classes.container },
            React.createElement("span", { className: 'info-label' }, t('info.password')),
            React.createElement("span", { className: cx('info-password-field info-value', classes.passwordContainer) },
                locked === LOCKED_LOCALLY ? (React.createElement("div", { className: 'info-password-local' }, this.props.visible ? this.props.password : '******')) : (React.createElement("div", { className: 'info-password-remote' }, this.props.t('passwordSetRemotely'))),
                this._renderPasswordField()))));
    }
    /**
     * Returns a ReactElement for showing the current state of the password or
     * for editing the current password.
     *
     * @private
     * @returns {ReactElement}
     */
    _renderPasswordField() {
        const { editEnabled, passwordNumberOfDigits, t } = this.props;
        if (editEnabled) {
            let placeHolderText = t('lobby.enterPasswordButton');
            if (passwordNumberOfDigits) {
                placeHolderText = this.props.t('passwordDigitsOnly', {
                    number: passwordNumberOfDigits,
                });
            }
            return (React.createElement("div", { className: this.props.classes.container },
                React.createElement("span", { className: 'info-label' }, t('info.password')),
                React.createElement(Input, { accessibilityLabel: t('info.addPassword'), autoFocus: true, className: this.props.classes.input, id: 'info-password-input', maxLength: passwordNumberOfDigits, mode: passwordNumberOfDigits ? 'numeric' : undefined, onChange: this._onEnteredPasswordChange, onKeyPress: this._onKeyPress, placeholder: placeHolderText, type: 'password', value: this.state.enteredPassword })));
        }
    }
}
export default withStyles(styles, {})(translate(IISightPasswordForm));
